<template>
    <div>
      <div class="overflow-auto">
        <ts-loading-banner :loading="waiting">
          <table id="table-details">
            <thead>
              <tr>
                <th class="ts-whitespace-no-wrap" style="width:250px">
                  {{ $t('invoice.feeType') }} / {{ $t('invoice.feeName') }}
                </th>
                <th class="ts-whitespace-no-wrap" style="width: 190px;">
                  {{ $t('invoice.description') }}
                </th>
                <th class="ts-whitespace-no-wrap" style="width: 70px;">
                  {{ $t('invoice.qty') }}
                </th>
                <th class="ts-whitespace-no-wrap" style="width: 99px;">
                  {{ $t('invoice.fee') }}
                </th>
                <th class="ts-whitespace-no-wrap" style="width: 93px;">
                  {{ $t('invoice.discountType') }}
                </th>
                <th class="ts-whitespace-no-wrap" style="width: 94px;">
                  {{ $t('invoice.discount') }}
                </th>
                <th class="ts-whitespace-no-wrap" style="width: 81px;">
                  {{ $t('invoice.vat') }}(%)
                </th>
                <th class="ts-whitespace-no-wrap" style="width: 90px;">
                  {{ $t('invoice.amount') }}
                </th>
                <th style="width:1%">
                  <a href="#" class="text-primary" @click.prevent="addRow">
                    <i class="fa fa-plus"></i>
                  </a>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(detail, index) in model.inv_detail_list" :key="index">
                <td valign="top">
                  <div class="ts-mb-1">
                    <a-select v-model.number="detail.fee_type_id" style="width: 100%" :options="feeTypes"
                      @change="onFeeTypeChange(detail)" :disabled="disableSelect" />
                    <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.fee_type_id')
                      ">
                      {{
                        errors.first('inv_detail_list.' + index + '.fee_type_id')
                      }}
                    </div>
                  </div>
                  <div>
                    <a-select v-model.number="detail.fee_setup_id" style="width:100%" :showSearch="true" :options="feeSetups
                        " :disabled="disableSelect" :filterOption="(input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        " optionFilterProp="children" @change="onFeeSetupChange(detail)" />
                    <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.fee_setup_id')
                        ">
                      {{
                        errors.first('inv_detail_list.' + index + '.fee_setup_id')
                      }}
                    </div>
                  </div>
                </td>
                <td valign="top">
                  <input v-model="detail.fee_description" type="text" class="form-control" />
                </td>
                <td valign="top">
                  <input type="number" min="1" class="form-control" v-model="detail.quantity" @input="calculate" />
                  <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.quantity')">
                    {{ errors.first('inv_detail_list.' + index + '.quantity') }}
                  </div>
                </td>
                <td valign="top">
                  <input readonly type="number" step="any" class="form-control" v-model="detail.fee_amount"
                    :disabled="detail.disabled" />
                  <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.fee_amount')">
                    {{ errors.first('inv_detail_list.' + index + '.fee_amount') }}
                  </div>
                </td>
                <td valign="top">
                  <a-select v-model="detail.discount_type" style="width: 100%" :options="[
                      { value: '$', label: '$' },
                      { value: '%', label: '%' }
                    ]" @change="calculate" />
                  <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.discount_type')
                    ">
                    {{
                      errors.first('inv_detail_list.' + index + '.discount_type')
                    }}
                  </div>
                </td>
                <td valign="top">
                  <input v-model="detail.discount_rate" type="number" class="form-control" @input="calculate" />
                </td>
                <td valign="top">
                  <input type="number" class="form-control" v-model="detail.vat_rate" @input="calculate" />
                </td>
                <td valign="top">
                  <input readonly type="number" class="form-control" v-model="detail.amount_include_vat" />
                </td>
                <td class="text-center" valign="top">
                  <a href="#" class="text-red ts-mt-3" @click.prevent="removeRow(detail)">
                    <i class="fa fa-trash"></i>
                  </a>
                </td>
              </tr>
              <tr class="bb">
                <td colspan="4" rowspan="6" valign="top" class="ts-text-right">
                  <div style="width: 400px" class="ts-float-right ts-space-y-3">
                    <div class="ts-grid ts-grid-cols-3 ts-gap-3">
                      <div class="ts-flex ts-items-center ts-justify-end">
												<label class="required">{{ $t('invoice.paymentMethod') }} :</label>
                      </div>
                      <div class="ts-col-span-2">
                        <select class="form-control" v-model="model.payment_method_id" @change="onPaymentMethodChange">
                          <option v-for="(p, index) in paymentMethods" :key="index" :value="p.id">{{ p.label }}</option>
                        </select>
												<div class="validate" v-if="errors.has('data.payment_method_id')">
                          {{ errors.first('data.payment_method_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="ts-grid ts-grid-cols-3 ts-gap-3">
                      <div class="ts-flex ts-items-center ts-justify-end">
                        <label>{{ $t('invoice.bankName') }} :</label>
                      </div>
                      <div class="ts-col-span-2">
                        <select v-model="model.bank_id" class="form-control" :disabled="model.payment_method_id == 1">
                          <option v-for="(b, index) in banks" :value="b.bank_id" :key="index">{{ b.bank_name }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </td>
                <td colspan="2" class="text-right">
                  <strong>{{ $t('invoice.totalAmount') }} :</strong>
                </td>
                <td colspan="3">
                  <input :value="model.total_amount" type="text" class="form-control" readonly />
                  <div class="validate" v-if="errors.has('total_amount')">
                    {{ errors.first('total_amount') }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="text-right">
                  <strong>{{ $t('invoice.fxRate') }} :</strong>
                </td>
                <td colspan="3">
                  <input :value="model.fx_rate" type="number" step="any" class="form-control" readonly>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="text-right">
                  <strong>{{ $t('invoice.paidInUsd') }} :</strong>
                </td>
                <td colspan="3">
                  <div class="ts-flex ts-items-center">
                    <input v-model.number="model.amount_paid_usd" type="number" step="any" class="form-control"
                    @input="customerPaid" />
                    <button 
                      @click.prevent="convertToKhr"
                      class="ts-p-2 ts-bg-blue-600 ts-rounded ts-ml-1 ts-text-white ts-flex ts-items-center"
                    ><i class="fas fa-arrow-down"></i></button>
                  </div>
                  <div class="validate" v-if="errors.has('amount_paid_usd')">
                    {{ errors.first('amount_paid_usd') }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="text-right">
                  <strong>{{ $t('invoice.paidInKhr') }} :</strong>
                </td>
                <td colspan="3">
                  <input v-model.number="model.amount_paid_khr" type="number" step="any" class="form-control"
                    @input="customerPaid" />
                  <div class="validate" v-if="errors.has('amount_paid_khr')">
                    {{ errors.first('amount_paid_khr') }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="text-right">
                  <strong>{{ $t('invoice.dueAmount') }} :</strong>
                </td>
                <td colspan="3">
                  <input v-model.number="model.amount_due" type="number" step="any" class="form-control" readonly />
                  <div class="validate" v-if="errors.has('amount_due')">
                    {{ errors.first('amount_due') }}
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="text-right">
                  <strong>{{ $t('invoice.nextPaymentDate') }} :</strong>
                </td>
                <td colspan="3">
                  <a-date-picker :disabled="allowPickNewPaymentDate" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
                    v-model="model.next_payment_date" style="width: 100%" />
                  <div class="validate" v-if="errors.has('next_payment_date')">
                    {{ errors.first('next_payment_date') }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ts-loading-banner>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from 'vuex'
  import { Errors } from 'form-backend-validation'
  import { debounce, round, ceil, sumBy } from 'lodash'
  import moment from 'moment'
  
  export default {
    name: 'itemFeeDetail',
    props: ['value', 'validate', 'bank'],
    data() {
      return {
        model: {},
        newRow: {
          fee_type_id: null,
          fee_setup_id: null,
          fee_description: null,
          quantity: 1,
          payment_term_id: null,
          fee_amount: 0,
          discount_type: '%',
          discount_rate: 0,
          discount_amount: 0,
          discount_reason: null,
          total_amount: 0,
          vat_rate: 0,
          vat_amount: 0,
          amount_include_vat: 0,
          ac_term_id: null,
          grade_id: null,
          disabled: false,
        },
        exchange_rate: 0,
        waiting: false,
        feeTypes: [],
        feeSetups: [],
        banks: [],
        feeSetupsWithDetail: [],
        errors: new Errors()
      }
    },
    created() {
      this.model = this.value
      this.addRow()
      this.fetchBankProfile()
      this.exchangeRates()
      this.fetchFeeType()
    },
    computed: {
      disableSelect() {
        return !(
          (this.model.student_id != '') | null &&
          (this.model.grade_id != null) | undefined
        )
      },
      allowPickNewPaymentDate() {
        return !this.model.amount_due > 0
      },
      paymentMethods() {
        return [
          { id: 1, label: 'Cash' },
          { id: 2, label: 'Cheque' },
          { id: 3, label: 'Bank Transfer' },
          { id: 4, label: 'Credit Card' }
        ]
      },
    },
    methods: {
      ...mapActions('officailReceiptModule', [
        'onGetFeeType',
        'onGetStudentFeeDetail',
        'onGetBank',
        'onGetExchange',
        'onGetFeeSetup'
      ]),
      fetchBankProfile() {
        this.onGetBank()
          .then(response => {
            this.banks = response.data.data
          })
      },
      fetchFeeType() {
        this.onGetFeeType()
        .then(response => {
          this.feeTypes = response.data.data.map(el => ({
            value: el.fee_type_id,
            label: el.fee_type_name
          }))
        })
      },
      fetchFeeSetup(item) {
        this.onGetFeeSetup({
          grade_id: this.model.grade_id
        })
        .then(response => (
          this.feeSetups = response.data.data.filter(el => el.fee_type_id == item.fee_type_id).map(el => ({
            value: el.fee_setup_id,
            label: el.fee_name_en
          }))
        ))
      },
      addRow() {
        this.model.inv_detail_list.push(_.clone(this.newRow))
      },
      removeRow(row) {
        this.model.inv_detail_list.splice(
          this.model.inv_detail_list.indexOf(row),
          1
        )
        this.model.total_amount = _.sumBy(
          this.model.inv_detail_list,
          'total_amount'
        )
        this.calculate()
      },
      onFeeTypeChange(item) {
        const hasFeeSetup = this.feeSetupsWithDetail.filter(f => f.fee_type_id == item.fee_type_id).length > 0;
        if(hasFeeSetup){
          this.fetchFeeSetup(item)
        }
        this.feeSetups = []
        item.fee_setup_id = null
        item.fee_description = null
        item.quantity = 1
        item.fee_amount = 0
        item.discount_type = '%'
        item.discount_rate = 0
        item.discount_amount = 0
        item.total_amount = 0
        item.vat_rate = 0
        item.vat_amount = 0
        item.amount_include_vat = 0
        this.calculate()
      },
      onFeeSetupChange(item) {
        this.feeSetupsWithDetail
          .filter(f => f.fee_setup_id == item.fee_setup_id)
          .forEach(el => {
            item.fee_description = el.fee_name_en // description is a fee name
            item.quantity = 1
            item.fee_amount = el.fee_amount
            item.discount_type = '%'
            item.grade_id = el.grade_id
          })
        this.calculate()
      },
      async studentFeeItemDetail() {
        this.loading = true
        this.model.inv_detail_list = []
        this.onGetStudentFeeDetail({
          grade_id: this.model.grade_id,
        }).then(response => {
          this.feeSetupsWithDetail = response.data.data
        }).finally(() => {
          this.loading = false; 
        });
        if(this.model.inv_detail_list.length == 0){
          this.model.inv_detail_list.push({
            fee_type_id: 1,
            quantity: 1,
            fee_amount: 0,
            discount_type: '%',
            discount_rate: 0,
            discount_amount: 0,
            total_amount: 0,
            vat_rate: 0,
            vat_amount: 0
          })
        }
        this.fetchFeeSetup(this.model.inv_detail_list[0])
      },
      onPaymentMethodChange() {
        if (this.model.payment_method_id == 1) {
          this.model.bank_id = null
        }
      },
      exchangeRates() {
        this.onGetExchange()
          .then(response => {
            this.model.fx_rate = response.data.exchange_rate
          })
      },
      customerPaid() {
        this.model.amount_paid  = this.model.amount_paid_usd + ( this.model.amount_paid_khr > 0 ? this.model.amount_paid_khr / this.model.fx_rate : 0)
        this.model.amount_due = _.round(
          this.model.total_amount - this.model.amount_paid,
          2
        )
        if (this.model.amount_due > 0) {
          this.model.next_payment_date = moment()
            .add(this.defaultCreditDay, 'Day')
            .format('DD-MM-YYYY')
        } else {
          this.model.next_payment_date = null
        }
      },
      convertToKhr(){
        this.model.amount_paid_khr = (this.model.total_amount - this.model.amount_paid) * this.model.fx_rate
        this.model.amount_due = 0
        this.model.next_payment_date = null
      },
      calculate() {
        let price = 0;
        if (this.model.inv_detail_list.length > 0) {
          this.model.inv_detail_list.forEach(item => {
            price = item.fee_amount ? item.fee_amount * item.quantity : 0
            if (item.discount_type == '%') {
              item.discount_amount = item.discount_rate
                ? price * round(item.discount_rate / 100, 4)
                : 0
            }
            if (item.discount_type == '$') {
              item.discount_amount = item.discount_rate
            }
            item.vat_amount =
              ((price - item.discount_amount) * item.vat_rate) / 100
            item.total_amount =
              ceil(price - item.discount_amount, 2) + item.vat_amount
            item.amount_include_vat = ceil(
              price - item.discount_amount + item.vat_amount,
              2
            )
            this.model.total_amount = sumBy(
              this.model.inv_detail_list,
              'total_amount'
            )
            this.model.amount_paid_usd = this.model.total_amount
            this.model.amount_paid_khr = 0,
            this.model.amount_paid = this.model.amount_paid_usd + ( this.model.amount_paid_khr > 0 ? this.model.amount_paid_khr / this.model.fx_rate : 0)
            this.customerPaid()
          })
        } else {
          this.model.amount_paid = 0
          this.model.amount_paid_usd = 0
          this.model.amount_paid_khr = 0
          this.model.total_amount = 0
          this.model.amount_due = 0
          this.model.next_payment_date = null
        }
      }
    },
    watch: {
      'model.grade_id': debounce(function(grade_id) {
        if (grade_id != undefined) {
          this.studentFeeItemDetail()
        } else {
          this.model.inv_detail_list = []
          this.model.payment_method_id = 1
          this.model.total_amount = 0
          this.model.amount_paid = 0
          this.model.amount_due = 0
          this.model.next_payment_date = null
        }
      }),
      validate: function (error) {
        this.errors = new Errors(error.errors)
      }
    }
  }
  </script>
  
  <style lang="css" scoped>
  * {
    font-size: 12px !important;
  }
  
  #table-details>thead>tr>th {
    padding: 5px 4px;
    background: #f2f3f4;
  }
  
  #table-details>tbody>tr>td {
    padding: 5px 4px;
    border: none !important;
    font-size: 12px !important;
  }
  
  .only-border-bottom {
    border-top: none;
    border-left: none;
    border-right: none;
  }
  </style>
  